import React from 'react'
import {useTranslation} from "react-i18next"
import {useSelector} from "react-redux"
import HIFEM_EN from "./HIFEM_EN"
import HIFEM_RU from "./HIFEM_RU"
import HIFEM_BG from "./HIFEM_BG"

const HIFEM = () => {
    const {t} = useTranslation()
    const language = useSelector(state => state.language)

    switch (language) {
        case 'EN':
            return (
                <HIFEM_EN/>
            )
        case 'RU':
            return (
                <HIFEM_RU/>
            )
        case 'BG':
            return (
                <HIFEM_BG/>
            )
        default:
            return (
                <HIFEM_EN/>
            )
    }
}

export default HIFEM



// WEBPACK FOOTER //
// ./src/Components/HIFEM/HIFEM.js